import { Component, input, computed, inject } from '@angular/core'
import { BoardsStore } from '@ziptility/tasks/boards/boards.store'
import { TaskBoardType } from '@ziptility/graphql'
import { UserAvatarComponent } from '@ziptility/components/user-avatar'

@Component({
  selector: 'task-board-badge',
  template: `
    @if (board(); as board) {
      <div class="my-1 flex items-start">
        @if (board.type === TaskBoardType.User) {
          <user-avatar [fullName]="board.name" [displayStyle]="'full'"></user-avatar>
        }
        @if (board.type === TaskBoardType.TaskList) {
          <div class="px-3 py-2 font-semibold inline-block flex-grow-0 rounded-full bg-gray-200">
            {{ board.name }}
          </div>
        }
      </div>
    }
  `,
  imports: [UserAvatarComponent],
})
export class TaskBoardBadgeComponent {
  readonly boardsStore = inject(BoardsStore)
  readonly boardId = input.required<string | undefined>()
  readonly TaskBoardType = TaskBoardType

  // Reactive computed property - updates automatically when boards load
  protected readonly board = computed(() => {
    const id = this.boardId()
    if (!id) return undefined
    return this.boardsStore.boardMap()[id]
  })
}
